import * as React from "react";
import { captureError } from "../lib/analytics.js";
import { MailtoContact } from "./MailtoContact.js";

interface State {
  err: Error | null;
}

interface Props {
  children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<Props, State> {
  override state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  override componentDidCatch(err: Error, info: React.ErrorInfo): void {
    if (typeof console !== "undefined") {
      console.error("portal error boundary:", err, info);
    }
    // React swallows render errors before window.onerror sees them, so report
    // explicitly. componentStack pinpoints which subtree threw.
    captureError(err, { componentStack: info.componentStack });
  }

  override render(): React.ReactNode {
    if (this.state.err) {
      return (
        <div className="state state-err" role="alert">
          <h2>Something broke.</h2>
          <p>
            Try reloading the page. If it keeps happening, email us at <MailtoContact />.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
